import { Component, HostListener, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { AppResource } from 'src/app/app.resource';
import { environment } from 'src/environments/environment';
import { PathType } from 'src/app/shared/enum/path-type.enum';
import { isMobile } from 'src/app/shared/utils/device-utils';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-web-callback',
  templateUrl: './web-callback.component.html',
  standalone: true,
  imports: [CommonModule]
})
export class WebCallbackComponent extends BaseComponent implements OnInit {
  show: boolean = false;
  phoneNumber!: string;
  path!: PathType;

  get brand() {
    return environment.brand;
  }

  constructor(resources: AppResource) {
    super(resources);
  }

  override ngOnInit(): void {
    this.phoneNumber = this.getPhoneNumber(this.path);
  }

  clickFunction() {
    this.show = !this.show;
  }

  callClientService(): void {
    if (isMobile()) {
      window.location.href = `tel:${this.phoneNumber}`;
    }
  }

  @HostListener('document:click', ['$event'])
  closeInfoModal() {
    this.show = false;
  }

  private getPhoneNumber(pathType: PathType) {
    switch (pathType) {
      case PathType.ANIMAL_HEALTH:
        return this.resource.webcallback.phoneDevis;
      default:
        return this.resource.webcallback.phoneDevis;
    }
  }
}
